import { DEFAULT_LOCALE } from "./localization.constants";
import { useLocale } from "./use-locale";

const localeMap: { [wacLocale: string]: string } = {
    [DEFAULT_LOCALE]: "",
    de: "de",
    es: "es",
    fr: "fr",
    it: "it",
    ko: "ko",
    nl: "nl",
    ja: "ja",
    pl: "pl",
    br: "br",
    ru: "ru",
    zh: "zh",
    ro: "ro",
    cs: "cs",
    hu: "hu",
    fi: "fi",
    xx: "xx"
};

export function useLocalizedPartnerdirectory() {
    const locale = useLocale();

    return `//partnerdirectory.atlassian.com/${
        localeMap[locale] || localeMap[DEFAULT_LOCALE]
    }`;
}
